module.exports = "/_next/static/images/StayingAheadOfTheCurve-sm-1c307a9be484fbd036eaf55a8c694ea0.png";